export interface Segment {
  name: string;
  options: string[];
  isDisabled?: boolean;
  is_other?: boolean;
  isOthersSegment?: boolean;
}

export enum PropertyGroupSplitBy {
  OWNER = "owner",
  MARKET = "market",
  STATE = "state_or_province",
  CITY = "city",
  ZIP = "postal_code"
}

export enum PropertyGroupStep {
  INITIAL_CONFIGURATION = "initial-configuration",
  OWNER = "owner",
  STATE = "state_or_province",
  CITY = "city",
  ZIP = "postal_code",
  MARKET = "market",
  CONFIRM_GROUPS = "confirm-groups"
}

export interface SankeyData {
  nodes: {
    id: string;
    nodeColor: string;
  }[];
  links: {
    source: string;
    target: string;
    value: number;
  }[];
}
